<template>
  <section class="evaluate">
    <ul class="tabList">
      <li v-for="item in tagList" :key="item.id">
        <el-button :class="{'tag':true,'active':activeTags.includes(item.id)}" @click="tagClick(item)">{{item.name}}</el-button>
      </li>
    </ul>
    <div class="inputWrapper">
      <el-input type="textarea" placeholder="评价..." v-model="textarea" maxlength="500" show-word-limit rows="6" @focus="inputFocus">
      </el-input>
      <div class="button-submit">
        <el-button :disabled="!isComment" type="primary" @click="pushComment">提交</el-button>
      </div>
    </div>
    <div class="noteList">
      <h2 class="title">评论区</h2>
      <div v-if="commentList.length>0">
        <div class="list" v-for="(item,index) in commentList" :key="index">
          <img class="headPortrait" :src="item.user_avatar" alt="作者头像" :onerror="errorAvatar" />
          <div class="note-content">
            <div class="header">
              <div class="info">
                <p class="name">{{item.user_name}}</p>
                <p class="date">{{item.create_time}}</p>
              </div>
              <div class="likes">
                <i :class="{'fabulous':item.is_up,'fabulousNormal':!item.is_up}" @click="giveLike(item.is_up,item.id)"></i>
                <em>{{item.up_num}}</em>
              </div>
            </div>
            <ul class="tags">
              <li class="tag" v-for="(tag,tagIndex) in item.comment_tag_label" :key="tagIndex">{{tag}}</li>
            </ul>
            <p class="paragraph">{{item.comment_content}}</p>
          </div>
        </div>
      </div>
      <NotData v-else :top="80"></NotData>
    </div>
    <ConfirmDialog :isShowConfirm="isShowConfirm" :isOneBtn="true" content="观看一个可课次后才可进行评价哦" @handleClose="handleClose" @handleConfirm="handleClose"></ConfirmDialog>
  </section>
</template>

<script>
export default {
  name: 'CourseEvaluate',
  data() {
    return {
      // 加载ing
      loading: false,
      // 是否可以评论
      isComment: false,
      // 提示弹窗显示
      isShowConfirm: false,
      // 评价内容
      textarea: '',
      // 全部的标签
      tagList: [],
      // 选择的标签
      activeTags: [],
      // 当前项目id
      projectId: '',
      // 评论列表
      commentList: [],
      // 错误头像
      errorAvatar: 'this.src="' + require('@/assets/image/defaultAvatar.png') + '"',
    }
  },
  created() {
    // 获取路由参数-项目id
    if (this.$route.params.id && this.$route.params.id !== '') {
      this.projectId = this.$route.params.id
    }
    // 获取评论列表
    this.getCommentList()
    // 获取全部的评价标签
    this.getTagList()
    // 评论校验
    this.commentCheck()
  },
  methods: {
    // 点击标签
    tagClick(item) {
      if (!this.activeTags.includes(item.id)) {
        this.activeTags.push(item.id)
      } else {
        this.activeTags.forEach((list, index) => {
          if (list === item.id) {
            this.activeTags.splice(index, 1)
          }
        })
      }
    },
    // 发表评论
    pushComment() {
      if (this.isComment) {
        this.loading = true
        this.$axios.$post(`/account/app/project_comment/add/v1`, {
          project_id: this.projectId,
          comment_content: this.textarea,
          comment_tag: this.activeTags
        }).then(res => {
          this.loading = false
          if (this.textarea !== '') {
            this.$message.success('您发布的评论需要审核，通过后会在评论区展示')
            this.activeTags = []
            this.textarea = ''
          } else {
            this.activeTags = []
            this.$message.success('评论提交成功')
            this.getCommentList()
          }
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.isShowConfirm = true
      }
    },
    // 点赞
    giveLike(type, id) {
      this.$axios.$post(`/knowledge/ups/v1/${type ? 'del' : 'insert'}`, {
        targetType: 3,  // 1:问题 2:回答 3:评价 4:文章
        targetId: id
      }).then(res => {
        this.commentList.forEach(item => {
          if (item.id === id) {
            if (type) {
              item.is_up = false
              item.up_num = item.up_num === 0 ? 0 : item.up_num - 1
            } else {
              item.is_up = true
              item.up_num += 1
            }
          }
        })
      }).catch(() => { })
    },
    // 评论列表
    getCommentList() {
      this.$axios.$get(`/account/app/project_comment/list/v1/${this.projectId}`, {
        params: {
          pageNum: 1,
          pageSize: 2000
        }
      }).then(res => {
        this.commentList = res.list
      }).catch(() => { })
    },
    // 获取全部的评价标签
    getTagList() {
      this.$axios.$get('/account/app/project_comment/tag_list/v1').then((res) => {
        this.tagList = res
      }).catch(() => { })
    },
    // 评论校验（是否可以进行评论）
    commentCheck() {
      this.$axios.$get('/learning/user/lesson/record/pc/comment/check/v1', {
        params: {
          projectId: this.projectId
        }
      }).then(res => {
        this.isComment = res
      }).catch(() => { })
    },
    // 评论框焦点事件
    inputFocus() {
      if (this.isComment) {
        return
      } else {
        this.isShowConfirm = true
      }
    },
    // 提示弹窗关闭
    handleClose() {
      this.isShowConfirm = false
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluate {
  margin-top: 30px;
  .tabList {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .tag {
      width: 104px;
      height: 34px;
      padding: 0;
      background: #f1f3f8;
      color: $default-font-color;
      border: 1px solid #f1f3f8;
      border-radius: 20px;
      font-size: 14px;
      margin: 0 17px 17px 0;
      &.active {
        background: rgba(225, 63, 55, 0.2);
        border: 1px solid $theme-color;
        color: $theme-color;
      }
    }
  }
  .inputWrapper {
    margin-top: 3px;
    border-bottom: 1px solid #f1f3f8;
    ::v-deep .el-textarea__inner {
      height: 160px;
      padding: 15px;
    }
    .button-submit {
      display: flex;
      justify-content: flex-end;
      .el-button {
        width: 104px;
        height: 32px;
        padding: 0;
        border-radius: 21px;
        font-size: 16px;
        margin: 20px 0;
      }
      .el-button--primary.is-disabled {
        background-color: $grey-font-color;
        border-color: $grey-font-color;
      }
    }
  }
  .noteList {
    min-height: 400px;
    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin: 20px 0;
    }
    .list {
      display: flex;
      margin-bottom: 30px;
      .headPortrait {
        margin-right: 5px;
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
      .note-content {
        flex: 1;
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .info {
            .name {
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
            .date {
              padding: 0;
              margin: 0;
              font-size: 10px;
              font-weight: 400;
              color: #bcc4d2;
              line-height: 14px;
            }
          }
          .likes {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              margin-right: 5px;
              cursor: pointer;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              &.fabulous {
                background-image: url("@/assets/image/fabulous.png");
              }
              &.fabulousNormal {
                background-image: url("@/assets/image/fabulousNormal.png");
              }
            }
          }
        }
        .tags {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .tag {
            width: auto;
            height: 24px;
            line-height: 24px;
            background: #f1f3f8;
            border-radius: 20px;
            padding: 0 10px;
            font-size: 12px;
            font-weight: 400;
            margin: 10px 10px 10px 0;
          }
        }
        .paragraph {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
